import HostMessages from '@/components/host/HostMessages'
import HostPlaylist from '@/components/host/HostPlaylist'
import Logo from '@/components/Logo'
import { useAuth } from '@/hooks/useAuth'
import { useHead } from '@unhead/react'
import { ListMusic, LogOut, MessageSquare } from 'lucide-react'
import { useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { Link, Navigate } from 'react-router-dom'

const TABS = [
  { id: 'recados', label: 'Recadinhos', icon: MessageSquare },
  { id: 'playlist', label: 'Playlist', icon: ListMusic },
] as const

type TabId = (typeof TABS)[number]['id']

function HostPanel() {
  const { loggedIn, isHost, hostId, fullName, logout } = useAuth()
  const [tab, setTab] = useState<TabId>('recados')

  useHead({
    title: 'Painel do locutor — Bonita FM',
    htmlAttrs: { lang: 'pt-BR' },
  })

  if (!loggedIn) return <Navigate to="/login" replace />
  if (!isHost || !hostId) return <Navigate to="/admin" replace />

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Toaster position="top-right" />
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-4xl items-center justify-between gap-3 px-3 py-3 sm:px-4">
          <div className="flex min-w-0 items-center gap-3">
            <Logo className="h-10 sm:h-[52px]" />
            <div className="min-w-0">
              <p className="text-[10px] font-bold uppercase tracking-wide text-slate-500 sm:text-xs">Painel do locutor</p>
              <p className="truncate text-sm font-semibold">Olá, {fullName}</p>
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-2">
            <Link to="/" className="rounded-full border border-slate-200 px-3 py-2 text-xs font-semibold sm:px-4 sm:text-sm">
              Ver site
            </Link>
            <button
              type="button"
              onClick={logout}
              className="inline-flex items-center gap-2 rounded-full bg-[#0b2ea8] px-3 py-2 text-xs font-bold text-white sm:px-4 sm:text-sm"
            >
              <LogOut size={16} /> Sair
            </button>
          </div>
        </div>
        <div className="mx-auto flex max-w-4xl gap-2 px-3 pb-3 sm:px-4">
          {TABS.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setTab(item.id)}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold ${
                tab === item.id ? 'bg-[#ffd21f] text-[#0b2ea8]' : 'bg-slate-100 text-slate-600'
              }`}
            >
              <item.icon size={16} /> {item.label}
            </button>
          ))}
        </div>
      </header>
      <main className="mx-auto max-w-4xl space-y-5 px-3 py-4 sm:px-4 sm:py-6">
        {tab === 'recados' ? <HostMessages hostId={hostId} /> : null}
        {tab === 'playlist' ? <HostPlaylist hostId={hostId} /> : null}
      </main>
    </div>
  )
}

export default HostPanel
